import React from 'react';
import { Evidence2, DictionaryObject } from '@eas/common-web';

import { useValidationSchema } from './dict-minimal-distances-determination-methods-schema';
import { EvidenceAPI, PageKey, EntityName } from '../../enums';
import { useDictionaryEvidence } from '../../components/evidence/dictionary-evidence/dictionary-evidence';

export function DictionaryMinimalDistancesDeterminationMethods() {
  const validationSchema = useValidationSchema();

  const evidence = useDictionaryEvidence<DictionaryObject>({
    identifier: PageKey.DICTIONARY_MINIMAL_DISTANCES_DETERMINATION_METHOD,
    apiProps: {
      url: EvidenceAPI.DICTIONARY_MINIMAL_DISTANCES_DETERMINATION_METHOD,
    },

    tableProps: {
      tableName: 'Způsob určení minimální vzdálenosti',
      defaultSorts: [],
      // reportTag: 'TODO:',
      showReportButton: false,
    },
    detailProps: {
      entityName: EntityName.MINIMAL_DISTANCES_DETERMINATION_METHOD,
      codePrefix: '',
      validationSchema,
      toolbarProps: {
        title: 'Způsob určení minimální vzdálenosti podle § 27d',
      },
    },
  });

  return <Evidence2 {...evidence} />;
}
